import { render, staticRenderFns } from "./PFandGFCompanyDashboard.vue?vue&type=template&id=216a6e70&scoped=true"
import script from "./PFandGFCompanyDashboard.vue?vue&type=script&lang=js"
export * from "./PFandGFCompanyDashboard.vue?vue&type=script&lang=js"
import style0 from "./PFandGFCompanyDashboard.vue?vue&type=style&index=0&id=216a6e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216a6e70",
  null
  
)

export default component.exports